export const IDENTITY_KEY_KNOWN = 'known_identity'
export const IDENTITY_KEY_ANONYMOUS = 'anonymous_identity'
export const IDENTITY_VALUE = 'set'
export const GA_COOKIE_NAME = '_ga'
let gaCookieId: string | undefined

/**
 * Sets the GA cookie ID from environment config.
 * This should be called during initialization.
 * @param cookieId - The GA cookie identifier
 */
export const setGaCookieId = (cookieId?: string): void => {
  gaCookieId = cookieId
}

/**
 * Gets the GA cookie ID from environment config.
 * Returns undefined if not set.
 * @returns The GA cookie identifier or undefined
 */
export const getGaCookieId = (): string | undefined => {
  return gaCookieId
}

export const FBP_COOKIE_NAME = '_fbp'
